module.exports = __webpack_public_path__ + "img/text6.f13c7072.png";